module.exports = __webpack_public_path__ + "static/media/logo-120x80.6fbcc1b8.jpg";